import { CloseOutlined } from "@ant-design/icons";

export const sharedClearIcon = <CloseOutlined aria-hidden="true" />;

export const sharedSelectAllowClear = {
  clearIcon: sharedClearIcon,
};

export const sharedInputAllowClear = {
  clearIcon: sharedClearIcon,
};
